import React, { Component } from "react";
import { Field } from "formik";
import CheckField from "../fields/CheckField";
import { injectIntl } from "react-intl";

class FieldsBasketballTwo extends Component {
  render() {
    const { intl } = this.props;
    return (
      <div>
        <Field
          name="basketballTwo"
          component={CheckField}
          label={intl.formatMessage({
            id: "basketball.two",
            defaultMessage: "2 kosze",
          })}
        />
      </div>
    );
  }
}

export default injectIntl(FieldsBasketballTwo);
